import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

const useStyles = createUseStyles((theme) => ({
    text: {
        color: theme.colors.primary
    }
}));

const PlainTextCell = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { plainText } = props;

    return (
        <div className={classes.text}>
            {plainText}
        </div>
    );
};

PlainTextCell.propTypes = {
    plainText: PropTypes.any
};

export { PlainTextCell };
